import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from 'src/component/ds/utils';

/* shadcn's Empty */

function Empty ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot='empty'
      className={cn(
        'ds-flex ds-min-w-0 ds-flex-1 ds-flex-col ds-items-center ds-justify-center ds-gap-4 ds-p-8 ds-text-center ds-text-balance',
        className
      )}
      {...props}
    />
  );
}

function EmptyHeader ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot='empty-header'
      className={cn('ds-flex ds-max-w-96 ds-flex-col ds-items-center ds-gap-1 ds-text-center', className)}
      {...props}
    />
  );
}

const emptyMediaVariants = cva(
  'ds-flex ds-shrink-0 ds-items-center ds-justify-center [&_svg]:ds-pointer-events-none [&_svg]:ds-shrink-0',
  {
    variants: {
      variant: {
        default: 'ds-bg-transparent',
        icon: "ds-size-12 ds-rounded-[10px] ds-bg-muted ds-text-muted-foreground [&_svg:not([class*='size-'])]:ds-size-6"
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

function EmptyMedia ({
  className,
  variant = 'default',
  ...props
}: React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof emptyMediaVariants>) {
  return (
    <div
      data-slot='empty-icon'
      data-variant={variant}
      className={cn(emptyMediaVariants({ variant, className }))}
      {...props}
    />
  );
}

function EmptyTitle ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot='empty-title'
      className={cn('ds-text-base ds-font-medium ds-text-foreground', className)}
      {...props}
    />
  );
}

function EmptyDescription ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot='empty-description'
      className={cn(
        'ds-text-sm ds-text-muted-foreground [&>a]:ds-underline [&>a]:ds-underline-offset-4 [&>a:hover]:ds-text-primary',
        className
      )}
      {...props}
    />
  );
}

function EmptyContent ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot='empty-content'
      className={cn(
        'ds-flex ds-w-full ds-max-w-96 ds-min-w-0 ds-flex-col ds-items-center ds-gap-4 ds-text-sm ds-text-balance',
        className
      )}
      {...props}
    />
  );
}

export {
  Empty,
  EmptyHeader,
  EmptyTitle,
  EmptyDescription,
  EmptyContent,
  EmptyMedia
};
